module.exports = __webpack_public_path__ + "img/Moves.f601a823.png";